import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import "../index.css"
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const TopNav = () => {
    const [mobile, setMobile] = useState(false)
    return (
        <div>
            <nav className='navbar'>
                
                <ul className={mobile ? "navlinks-mobile" : 'topnavlinks'} onClick={() => setMobile(false)}>
                    <Link to='/'> <li>Home</li> </Link>
                    <Link to='/activies'> <li>Activies</li> </Link>
                    <Link to='/facilities'> <li>Facilities</li> </Link>
                    <Link to='/alumini'> <li>Alumini</li> </Link>
                </ul>

                <button className='mobile-Menu-Icon' onClick={() => setMobile(!mobile)}>
                    {
                        mobile ? <ImCross /> : <FaBars />
                    }

                </button>

            </nav>
        </div>
    );
}

export default TopNav;
